import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';
import Select from 'react-select';

import { mapId, mapName } from 'helpers/react_select_helpers';

export default class DocTemplateSelectorModal extends React.Component {

  static propTypes = {
    docTemplateOptions: PropTypes.array,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  state = {
    docTemplateId: null,
    submitting: false
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitting: true });
    this.props.onSubmit(this.state.docTemplateId);
  }

  handleTemplateChange = (template) => {
    this.setState({ docTemplateId: template.id });
  }

  disableSubmit = () => {
    return this.state.submitting || (this.state.docTemplateId == null);
  }

  render() {
    return (
      <Modal
        className="visible-overflow"
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Select a document template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            getOptionLabel={mapName}
            getOptionValue={mapId}
            options={this.props.docTemplateOptions}
            onChange={this.handleTemplateChange}
          />
          <div className="text-end mt-5">
            <a
              className="btn btn-primary"
              disabled={this.disableSubmit()}
              href="#"
              name="createDocumentLink"
              onClick={this.handleSubmit}
            >
              Create New Document
            </a>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
